/* eslint-disable no-debugger */
/* eslint-disable @typescript-eslint/no-unused-expressions */
/* eslint-disable @typescript-eslint/no-unused-vars */
"use client";
/*eslint no-unused-vars: 0*/

import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import History from "../history";
import { uuid4 } from "../utils";
import Arrow from "../tools/Arrow";
import Tool, { Tools } from "../tools";
import DefaultTool from "../tools/defaul-tool";
import Select from "../tools/Select";
import Pencil from "../tools/Pencil";
import Marker from "../tools/Marker";
import Eraser from "../tools/Eraser";
import Line from "../tools/Line";
import Rectangle from "../tools/Rectangle";
import Crop from "../tools/Crop";
import RectangleLabel from "../tools/Rectangle/rectangle-label";
import Triangle from "../tools/Triangle";
import AddNote from "../tools/AddNote";
import Text from "../tools/Text";
import Polygon from "../tools/Polygon";
import Circle from "../tools/Circle";
import Pan from "../tools/Pan";
import DashedLine from "../tools/DashedLine";
import Highlighter from "../tools/Highlighter";
import { fabric } from "../fabric/dist/fabric";
import { IconInitializer } from "../icons";
import {
  DisplayTypes,
  EraserShortCuts,
  PageIconType,
  PageNavigationDirection,
} from "@/types";
import { SvgIcons } from "../svgIcons";
import CanvasManager from "../managers/CanvasManager";
import IconManager from "../managers/IconManager";
import { ImageManager } from "../managers/ImageManager";
import PageImageManager from "../managers/PageImageManager";
import StrategyManager from "../managers/StrategyManager";
import {
  CloseGapFillingStrategy,
  CloseQuestionAnswerStrategy,
  OpenGapFillingStrategy,
  OpenQuestionAnswerStrategy,
  CollapseSecondLayerStrategy,
} from "../managers/IconClickStrategy";
import Hammer from "hammerjs";

/**
 * Sketch Tool based on FabricJS for React Applications
 */
class SketchField extends PureComponent {
  static propTypes = {
    // the color of the line
    lineColor: PropTypes.string,
    // The width of the line
    lineWidth: PropTypes.number,
    // the fill color of the shape when applicable
    fillColor: PropTypes.string,
    // the background color of the sketch
    backgroundColor: PropTypes.string,
    // the opacity of the object
    opacity: PropTypes.number,
    // number of undo/redo steps to maintain
    undoSteps: PropTypes.number,
    // The tool to use, can be pencil, rectangle, circle, brush;
    tool: PropTypes.string,
    // image format when calling toDataURL
    imageFormat: PropTypes.string,
    // Sketch data for controlling sketch from
    // outside the component
    value: PropTypes.object,
    // Set to true if you wish to force load the given value, even if it is  the same
    forceValue: PropTypes.bool,
    // Specify some width correction which will be applied on auto resize
    widthCorrection: PropTypes.number,
    // Specify some height correction which will be applied on auto resize
    heightCorrection: PropTypes.number,
    // Specify action on change
    onChange: PropTypes.func,
    // Specify action on zoom change
    onZoomChange: PropTypes.func,
    // Default initial value
    defaultValue: PropTypes.object,
    // Sketch width
    width: PropTypes.number,
    // Sketch height
    height: PropTypes.number,
    // event object added
    onObjectAdded: PropTypes.func,
    // event object modified
    onObjectModified: PropTypes.func,
    // event object removed
    onObjectRemoved: PropTypes.func,
    // event mouse down
    onMouseDown: PropTypes.func,
    // event mouse move
    onMouseMove: PropTypes.func,
    // event mouse up
    onMouseUp: PropTypes.func,
    // event mouse out
    onMouseOut: PropTypes.func,
    // event object move
    onObjectMoving: PropTypes.func,
    // event object scale
    onObjectScaling: PropTypes.func,
    // event object rotating
    onObjectRotating: PropTypes.func,
    // event crop image
    onImageCrop: PropTypes.func,
    // Class name to pass to container div of canvas
    className: PropTypes.string,
    // Style options to pass to container div of canvas
    style: PropTypes.object,
  };

  static defaultProps = {
    lineColor: "black",
    lineWidth: 10,
    fillColor: "transparent",
    backgroundColor: "transparent",
    opacity: 1.0,
    undoSteps: 25,
    tool: null,
    widthCorrection: 0,
    heightCorrection: 0,
    forceValue: false,
    onObjectAdded: () => null,
    onObjectModified: () => null,
    onObjectRemoved: () => null,
    onMouseDown: () => null,
    onMouseMove: () => null,
    onMouseUp: () => null,
    onMouseOut: () => null,
    onObjectMoving: () => null,
    onObjectScaling: () => null,
    onObjectRotating: () => null,
  };

  state = {
    action: true,
  };
  _eraserShortCutActive = false;
  imgLeft = 0;
  imgTop = 0;
  iconInitializer = new IconInitializer();
  _hammertime = null;
  _maxZoom = 8;
  _minZoom = 0.7;

  _initTools = (fabricCanvas) => {
    this._tools = {};
    this._tools[Tool.Select] = new Select(fabricCanvas);
    this._tools[Tool.Pencil] = new Pencil(fabricCanvas);
    this._tools[Tool.Marker] = new Marker(fabricCanvas);
    this._tools[Tool.Eraser] = new Eraser(fabricCanvas);
    this._tools[Tool.Line] = new Line(fabricCanvas);
    this._tools[Tool.DashedLine] = new DashedLine(fabricCanvas);
    this._tools[Tool.Arrow] = new Arrow(fabricCanvas);
    this._tools[Tool.Rectangle] = new Rectangle(fabricCanvas);
    this._tools[Tool.RectangleLabel] = new RectangleLabel(fabricCanvas);
    this._tools[Tool.Crop] = new Crop(fabricCanvas);
    this._tools[Tool.Triangle] = new Triangle(fabricCanvas);
    this._tools[Tool.AddNote] = new AddNote(fabricCanvas);
    this._tools[Tool.Text] = new Text(fabricCanvas);
    this._tools[Tool.Polygon] = new Polygon(fabricCanvas);
    this._tools[Tool.Circle] = new Circle(fabricCanvas);
    this._tools[Tool.Pan] = new Pan(fabricCanvas);
    this._tools[Tool.Highlighter] = new Highlighter(fabricCanvas);
    this._tools[Tool.DefaultTool] = new DefaultTool(fabricCanvas);
  };

  _initManagers = (fabricCanvas) => {
    this.canvasManager = new CanvasManager(fabricCanvas);
    this.imageManager = new ImageManager(this.canvasManager);
    this.pageImageManager = new PageImageManager(
      this.canvasManager,
      this.imageManager
    );
    this.strategyManager = new StrategyManager();
    this.strategyManager.registerStrategy(
      "OpenGapFilling",
      new OpenGapFillingStrategy()
    );
    this.strategyManager.registerStrategy(
      "CloseGapFilling",
      new CloseGapFillingStrategy()
    );

    this.strategyManager.registerStrategy(
      "OpenQuestionAnswer",
      new OpenQuestionAnswerStrategy()
    );
    this.strategyManager.registerStrategy(
      "CloseQuestionAnswer",
      new CloseQuestionAnswerStrategy()
    );

    this.strategyManager.registerStrategy(
      "CollapseSecondLayer",
      new CollapseSecondLayerStrategy()
    );
    this.iconManager = new IconManager(
      this.canvasManager,
      this.imageManager,
      this.strategyManager,
      this.onIconClicked,
      this.onNotePositionChanged
    );
  };

  /**
   * Enable touch Scrolling on Canvas
   */
  enableTouchScroll = () => {
    let canvas = this._fc;
    if (canvas.allowTouchScrolling) return;
    canvas.allowTouchScrolling = true;
  };

  /**
   * Disable touch Scrolling on Canvas
   */
  disableTouchScroll = () => {
    let canvas = this._fc;
    if (canvas.allowTouchScrolling) {
      canvas.allowTouchScrolling = false;
    }
  };

  /**
   * Add an image as object to the canvas
   *
   * @param dataUrl the image url or Data Url
   * @param options object to pass and change some options when loading image, the format of the object is:
   *
   * {
   *   left: <Number: distance from left of canvas>,
   *   top: <Number: distance from top of canvas>,
   *   scale: <Number: initial scale of image>
   * }
   */
  addImg = (dataUrl, options = {}) => {
    let canvas = this._fc;
    fabric.Image.fromURL(dataUrl, (oImg) => {
      let opts = {
        left: Math.random() * (canvas.getWidth() - oImg.width * 0.5),
        top: Math.random() * (canvas.getHeight() - oImg.height * 0.5),
        scale: 0.5,
      };
      Object.assign(opts, options);
      oImg.scale(opts.scale);
      oImg.set({
        left: opts.left,
        top: opts.top,
      });
      canvas.add(oImg);
    });
  };

  /**
   * Action when an object is added to the canvas
   */
  _onObjectAdded = (e) => {
    const { onObjectAdded } = this.props;
    if (!this.state.action) {
      this.setState({ action: true });
      return;
    }
    let obj = e.target;
    obj.__version = 1;
    // record current object state as json and save as originalState
    let objState = obj.toJSON();
    obj.__originalState = objState;
    let state = JSON.stringify(objState);
    // object, previous state, current state
    this._history.keep([obj, state, state]);
    onObjectAdded(e);
  };

  /**
   * Action when an object is moving around inside the canvas
   */
  _onObjectMoving = (e) => {
    const { onObjectMoving } = this.props;
    onObjectMoving(e);
  };

  /**
   * Action when an object is scaling inside the canvas
   */
  _onObjectScaling = (e) => {
    const { onObjectScaling } = this.props;
    onObjectScaling(e);
  };

  /**
   * Action when an object is rotating inside the canvas
   */
  _onObjectRotating = (e) => {
    const { onObjectRotating } = this.props;
    onObjectRotating(e);
  };

  _onObjectModified = (e) => {
    const { onObjectModified } = this.props;
    let obj = e.target;
    obj.__version += 1;
    let prevState = JSON.stringify(obj.__originalState);
    let objState = obj.toJSON();
    // record current object state as json and update to originalState
    obj.__originalState = objState;
    let currState = JSON.stringify(objState);
    this._history.keep([obj, prevState, currState]);
    onObjectModified(e);
  };

  /**
   * Action when an object is removed from the canvas
   */
  _onObjectRemoved = (e) => {
    const { onObjectRemoved } = this.props;
    let obj = e.target;
    if (obj.__removed) {
      obj.__version += 1;
      return;
    }
    obj.__version = 0;
    onObjectRemoved(e);
  };

  /**
   * Action when the mouse button is pressed down
   */
  _onMouseDown = (e) => {
    const { onMouseDown } = this.props;
    this._selectedTool.doMouseDown(e);
    this.pageImageManager.onMouseDown(e);
    onMouseDown(e);
  };

  /**
   * Action when the mouse cursor is moving around within the canvas
   */
  _onMouseMove = (e) => {
    const { onMouseMove } = this.props;
    const canvas = this._fc;
    if (canvas.cancelDraw === undefined || canvas.cancelDraw === false) {
      this._selectedTool.doMouseMove(e);
    }
    onMouseMove(e);
  };

  /**
   * Action when the mouse cursor is moving out from the canvas
   */
  _onMouseOut = (e) => {
    const { onMouseOut } = this.props;
    this._selectedTool.doMouseOut(e);
    if (this.props.onChange) {
      let onChange = this.props.onChange;
      setTimeout(() => {
        onChange(e.e);
      }, 10);
    }
    onMouseOut(e);
  };

  _onMouseUp = (e) => {
    const { onMouseUp, onImageCrop } = this.props;
    this._selectedTool.doMouseUp(e);
    // Update the final state to new-generated object
    // Ignore Path object since it would be created after mouseUp
    // Assumed the last object in canvas.getObjects() in the newest object
    if (
      this.props.tool === Tool.Crop &&
      this._selectedTool._canvas.backgroundImage
    ) {
      const canvas = this._fc;
      const zoom = canvas.getZoom();
      const scaleX = this._selectedTool._canvas.backgroundImage.scaleX * zoom;
      const scaley = this._selectedTool._canvas.backgroundImage.scaleY * zoom;
      const left = this._selectedTool._canvas.backgroundImage.lineCoords.tl.x;
      const top = this._selectedTool._canvas.backgroundImage.lineCoords.tl.y;
      const rect = this._selectedTool.rect;
      if (this._selectedTool.rect) {
        onImageCrop({
          left: (rect.lineCoords.tl.x - left) / scaleX,
          top: (rect.lineCoords.tl.y - top) / scaley,
          width: (rect.lineCoords.br.x - rect.lineCoords.bl.x) / scaleX,
          height: (rect.lineCoords.br.y - rect.lineCoords.tr.y) / scaleX,
        });
      }
    }

    if (this.props.tool !== Tool.Pencil) {
      const canvas = this._fc;
      const objects = canvas.getObjects();
      const newObj = objects[objects.length - 1];
      if (newObj && newObj.__version === 1) {
        newObj.__originalState = newObj.toJSON();
      }
    }
    if (this.props.onChange) {
      let onChange = this.props.onChange;
      setTimeout(() => {
        onChange(e.e);
      }, 10);
    }
    this.pageImageManager.onMouseUp(e);
  };

  _onZoomChange = () => {
    this.pageImageManager.onZoomChange();
  };

  /**
   * Track the resize of the window and update our state
   *
   * @param e the resize event
   * @private
   */
  _resize = (e, canvasWidth = null, canvasHeight = null) => {
    if (e) e.preventDefault();
    let { widthCorrection, heightCorrection } = this.props;
    let canvas = this._fc;
    let { offsetWidth, clientHeight } = this._container;
    let prevWidth = canvasWidth || canvas.getWidth();
    let prevHeight = canvasHeight || canvas.getHeight();
    let wfactor = ((offsetWidth - widthCorrection) / prevWidth).toFixed(2);
    let hfactor = ((clientHeight - heightCorrection) / prevHeight).toFixed(2);
    canvas.setWidth(offsetWidth - widthCorrection);
    canvas.setHeight(clientHeight - heightCorrection);
    if (canvas.backgroundImage) {
      // Need to scale background images as well
      let bi = canvas.backgroundImage;
      bi.width = bi.width * wfactor;
      bi.height = bi.height * hfactor;
    }
    let objects = canvas.getObjects();
    for (let i in objects) {
      let obj = objects[i];
      let scaleX = obj.scaleX;
      let scaleY = obj.scaleY;
      let left = obj.left;
      let top = obj.top;
      let tempScaleX = scaleX * wfactor;
      let tempScaleY = scaleY * hfactor;
      let tempLeft = left * wfactor;
      let tempTop = top * hfactor;
      obj.scaleX = tempScaleX;
      obj.scaleY = tempScaleY;
      obj.left = tempLeft;
      obj.top = tempTop;
      obj.setCoords();
    }
    canvas.renderAll();
    canvas.calcOffset();
  };

  /**
   * Sets the background color for this sketch
   * @param color in rgba or hex format
   */
  _backgroundColor = (color) => {
    if (!color) return;
    let canvas = this._fc;
    canvas.setBackgroundColor(color, () => canvas.renderAll());
  };

  /**
   * Zoom the drawing by the factor specified
   *
   * The zoom factor is a percentage with regards the original, for example if factor is set to 2
   * it will double the size whereas if it is set to 0.5 it will half the size
   *
   * @param factor the zoom factor
   */
  zoom = (factor) => {
    let canvas = this._fc;
    let objects = canvas.getObjects();
    for (let i in objects) {
      objects[i].scaleX = objects[i].scaleX * factor;
      objects[i].scaleY = objects[i].scaleY * factor;
      objects[i].left = objects[i].left * factor;
      objects[i].top = objects[i].top * factor;
      objects[i].setCoords();
    }
    canvas.renderAll();
    canvas.calcOffset();
  };

  zoomInOut = (type, sensivity) => {
    const canvas = this._fc;
    const { displayType } = this.props;
    const center = canvas.getCenter();
    const pointX = displayType === DisplayTypes.PageItem ? 0 : center.left;
    sensivity = sensivity !== undefined ? sensivity : 0.2;
    const zoomFactor =
      canvas.getZoom() + (type === "zoomin" ? sensivity : -sensivity);
    this.pinchzoom(zoomFactor, pointX, 0);
  };

  absolutePan = (isNext) => {
    const canvas = this._fc;
    if (
      !canvas.backgroundImage ||
      canvas.backgroundImage.lineCoords === null ||
      canvas.backgroundImage.lineCoords === undefined
    ) {
      return false;
    }
    if (
      canvas.height >=
      canvas.backgroundImage.lineCoords.bl.y -
        canvas.backgroundImage.lineCoords.tl.y
    ) {
      return false;
    } else {
      const zoom = canvas.getZoom();
      if (isNext) {
        let bottomPan = -200 * zoom;
        if (canvas.backgroundImage.lineCoords.br.y < canvas.height) {
          return false;
        }
        if (
          canvas.backgroundImage.lineCoords.br.y - canvas.height - 80 <
          200 * zoom
        ) {
          bottomPan =
            -(canvas.backgroundImage.lineCoords.br.y - canvas.height) - 80;
        }
        canvas.relativePan(new fabric.Point(0, bottomPan));
      } else {
        if (canvas.backgroundImage.lineCoords.tl.y >= 0) {
          return false;
        }
        let topPan = 0;
        if (-canvas.backgroundImage.lineCoords.tl.y < 200 * zoom) {
          topPan = -canvas.backgroundImage.lineCoords.tl.y;
        } else {
          topPan = 200 * zoom;
        }
        canvas.relativePan(new fabric.Point(0, topPan));
      }
      return true;
    }
  };

  pinchzoom = (factor, pointX, pointY) => {
    const canvas = this._fc;
    if (factor > this._minZoom && factor <= this._maxZoom) {
      canvas.zoomToPoint(new fabric.Point(pointX, pointY), factor);
      const { onZoomChange } = this.props;
      onZoomChange(factor);
      canvas.renderAll();
      canvas.calcOffset();
      this._onZoomChange();
    }
  };

  resetBox = () => {
    const canvas = this._fc;
    const object = canvas.backgroundImage;
    if (object !== null) {
      const panX = object.aCoords?.tl?.x - object.lineCoords?.tl?.x;
      const panY = object.aCoords?.tl?.y - object.lineCoords?.tl?.y;
      if (panX && panY) {
        const delta = new fabric.Point(panX, panY);
        canvas.relativePan(delta);
      }
    }
  };
  expandCanvas = (displayType) => {
    const canvas = this._fc;
    const center = canvas.getCenter();
    const zoom = canvas.getZoom();
    let zoomScale = 0;

    if (zoom !== 1 || displayType === DisplayTypes.PageItem) {
      zoomScale = 0;
      this.pinchzoom(1, center.left, 0);
      this.resetBox();
    } else if (displayType === DisplayTypes.Page) {
      zoomScale =
        canvas.width /
        (canvas.backgroundImage.width *
          (5 / 4) *
          canvas.backgroundImage.scaleX);
      this.resetBox();
      this.pinchzoom(zoomScale, center.left, 0);
    }
  };

  /**
   * Perform an undo operation on canvas, if it cannot undo it will leave the canvas intact
   */
  undo = () => {
    let history = this._history;
    if (
      !history ||
      typeof history.getCurrent !== "function" ||
      typeof history.undo !== "function"
    ) {
      console.error("History objesi geçersiz veya metotlar eksik!");
      return;
    }

    const current = history.getCurrent();
    if (!current) {
      console.error("Geçerli bir durum bulunamadı!");
      return;
    }

    let [obj, prevState, currState] = current;

    if (!obj || typeof obj !== "object") {
      console.error("Geçersiz obj nesnesi:", obj);
      return;
    }

    history.undo();
    if (obj.__removed) {
      this.setState({ action: false }, () => {
        this._fc.add(obj);
        obj.__version -= 1;
        obj.__removed = false;
      });
    } else if (obj.__version <= 1) {
      this._fc.remove(obj);
    } else {
      obj.__version -= 1;
      obj.setOptions(JSON.parse(prevState));
      obj.setCoords();
      this._fc.renderAll();
    }

    if (this.props.onChange) {
      this.props.onChange();
    }
  };

  /**
   * Perform a redo operation on canvas, if it cannot redo it will leave the canvas intact
   */
  redo = () => {
    let history = this._history;
    if (history.canRedo()) {
      let canvas = this._fc;
      //noinspection Eslint
      let [obj, prevState, currState] = history.redo();
      if (obj.__version === 0) {
        this.setState({ action: false }, () => {
          canvas.add(obj);
          obj.__version = 1;
        });
      } else {
        obj.__version += 1;
        obj.setOptions(JSON.parse(currState));
      }
      obj.setCoords();
      canvas.renderAll();
      if (this.props.onChange) {
        this.props.onChange();
      }
    }
  };

  /**
   * Delegation method to check if we can perform an undo Operation, useful to disable/enable possible buttons
   *
   * @returns {*} true if we can undo otherwise false
   */
  canUndo = () => {
    return this._history.canUndo();
  };

  /**
   * Delegation method to check if we can perform a redo Operation, useful to disable/enable possible buttons
   *
   * @returns {*} true if we can redo otherwise false
   */
  canRedo = () => {
    return this._history.canRedo();
  };

  /**
   * Exports canvas element to a dataurl image. Note that when multiplier is used, cropping is scaled appropriately
   *
   * Available Options are
   * <table style="width:100%">
   *
   * <tr><td><b>Name</b></td><td><b>Type</b></td><td><b>Argument</b></td><td><b>Default</b></td><td><b>Description</b></td></tr>
   * <tr><td>format</td> <td>String</td> <td><optional></td><td>png</td><td>The format of the output image. Either "jpeg" or "png"</td></tr>
   * <tr><td>quality</td><td>Number</td><td><optional></td><td>1</td><td>Quality level (0..1). Only used for jpeg.</td></tr>
   * <tr><td>multiplier</td><td>Number</td><td><optional></td><td>1</td><td>Multiplier to scale by</td></tr>
   * <tr><td>left</td><td>Number</td><td><optional></td><td></td><td>Cropping left offset. Introduced in v1.2.14</td></tr>
   * <tr><td>top</td><td>Number</td><td><optional></td><td></td><td>Cropping top offset. Introduced in v1.2.14</td></tr>
   * <tr><td>width</td><td>Number</td><td><optional></td><td></td><td>Cropping width. Introduced in v1.2.14</td></tr>
   * <tr><td>height</td><td>Number</td><td><optional></td><td></td><td>Cropping height. Introduced in v1.2.14</td></tr>
   *
   * </table>
   *
   * @returns {String} URL containing a representation of the object in the format specified by options.format
   */
  toDataURL = (options) => this._fc.toDataURL(options);

  /**
   * Returns JSON representation of canvas
   *
   * @param propertiesToInclude Array <optional> Any properties that you might want to additionally include in the output
   * @returns {string} JSON string
   */
  toJSON = (propertiesToInclude) => this._fc.toJSON(propertiesToInclude);

  /**
   * Populates canvas with data from the specified JSON.
   *
   * JSON format must conform to the one of fabric.Canvas#toDatalessJSON
   *
   * @param json JSON string or object
   */
  fromJSON = (json) => {
    if (!json) return;
    let canvas = this._fc;
    setTimeout(() => {
      canvas.loadFromJSON(json, () => {
        if (this.props.tool === Tool.DefaultTool) {
          canvas.isDrawingMode = canvas.selection = false;
          canvas.forEachObject((o) => (o.selectable = o.evented = false));
        }
        canvas.renderAll();
        if (this.props.onChange) {
          this.props.onChange();
        }
      });
    }, 100);
  };

  /**
   * Clear the content of the canvas, this will also clear history but will return the canvas content as JSON to be
   * used as needed in order to undo the clear if possible
   *
   * @param propertiesToInclude Array <optional> Any properties that you might want to additionally include in the output
   * @returns {string} JSON string of the canvas just cleared
   */
  clear = (propertiesToInclude) => {
    const canvas = this._fc;
    const objects = canvas.getObjects();
    if (objects) {
      // this.props.onChange()
      // let selected = [];
      objects.forEach((obj) => {
        if (!obj.pageIcon) {
          // obj.__removed = true;
          // let objState = obj.toJSON();
          // obj.__originalState = objState;
          canvas.remove(obj);
        }
      });
      canvas.discardActiveObject();
      canvas.requestRenderAll();
      this.props.onChange();
    }
    this._history.clear();
    const discarded = this.toJSON(propertiesToInclude);
    return discarded;
  };

  hasSelection = () => {
    let canvas = this._fc;
    return !!canvas.getActiveObject();
  };

  clearSelection = () => {
    let canvas = this._fc;
    canvas.discardActiveObject();
    canvas.requestRenderAll();
  };

  /**
   * Remove selected object from the canvas
   */
  removeSelected = () => {
    let canvas = this._fc;
    let activeObj = canvas.getActiveObject();
    if (activeObj) {
      let selected = [];
      if (activeObj.type === "activeSelection") {
        activeObj.forEachObject((obj) => selected.push(obj));
      } else {
        selected.push(activeObj);
      }
      selected.forEach((obj) => {
        obj.__removed = true;
        let objState = obj.toJSON();
        obj.__originalState = objState;
        let state = JSON.stringify(objState);
        this._history.keep([obj, state, state]);
        canvas.remove(obj);
      });
      canvas.discardActiveObject();
      canvas.requestRenderAll();
    }
  };
  cloneObject = () => {
    this.copy();
    this.paste();
  };
  copy = () => {
    let canvas = this._fc;
    canvas.getActiveObject().clone((cloned) => (this._clipboard = cloned));
  };

  paste = () => {
    // clone again, so you can do multiple copies.
    this._clipboard.clone((clonedObj) => {
      let canvas = this._fc;
      canvas.discardActiveObject();
      clonedObj.set({
        left: clonedObj.left + 10,
        top: clonedObj.top + 10,
        evented: true,
      });
      if (clonedObj.type === "activeSelection") {
        // active selection needs a reference to the canvas.
        clonedObj.canvas = canvas;
        clonedObj.forEachObject((obj) => canvas.add(obj));
        clonedObj.setCoords();
      } else {
        canvas.add(clonedObj);
      }
      this._clipboard.top += 10;
      this._clipboard.left += 10;
      canvas.setActiveObject(clonedObj);
      canvas.requestRenderAll();
    });
  };

  clearItems = async () => {
    const canvas = this._fc;
    canvas.getObjects().forEach(function (object, key) {
      canvas.remove(object);
    });
    canvas.discardActiveObject();
    canvas.requestRenderAll();
  };

  fabricImageFromURL = async (image_url) => {
    return new Promise(function (resolve, reject) {
      try {
        fabric.Image.fromURL(image_url, function (image) {
          resolve(image);
        });
      } catch (error) {
        reject(error);
      }
    });
  };

  //for smartbook

  // Activiy Events

  completeActivity = () => {
    return this.pageImageManager?.currentExercise?.onComplete();
  };
  resetActivity = () => {
    return this.pageImageManager?.currentExercise?.onReset();
  };
  showActivityAnswer = () => {
    return this.pageImageManager?.currentExercise?.onShowAnswer();
  };
  showPreviousAnswer = () => {
    return this.pageImageManager?.currentExercise?.onShowPreviousAnswer();
  };
  showNextAnswer = () => {
    return this.pageImageManager?.currentExercise?.onShowNextAnswer();
  };

  onIconClicked = async (item) => {
    const { onIconClick } = this.props;
    onIconClick(item);
  };

  onNotePositionChanged = async (item) => {
    const { onNotePositionChange } = this.props;
    onNotePositionChange(item);
  };
  addNoteIcon = async (pageIcon) => {
    const canvas = this._fc;
    const onIconClick = this.onIconClicked;
    const { onNotePositionChange, height } = this.props;
    this.iconInitializer.getIcon(0, 0, pageIcon, (clonedIcon) => {
      let currentDrawingMode = true;
      clonedIcon.draggable = true;
      let startLeft = 0;
      let startTop = 0;
      // İkon tıklama öncesi drawing mode kapatma
      clonedIcon.on("mousedown:before", function () {
        canvas.selection = true;
        canvas.defaultCursor = "default";
        currentDrawingMode = canvas.isDrawingMode;
        canvas.isDrawingMode = false;
      });
      // İkon tıklandığında drawing mode'u geri getirme
      clonedIcon.on("mousedown", function () {
        startLeft = clonedIcon.left;
        startTop = clonedIcon.top;
        canvas.selection = true;
      });
      clonedIcon.on("mouseup", function () {
        canvas.selection = false;
        canvas.isDrawingMode = currentDrawingMode;
        const endLeft = clonedIcon.left;
        const endTop = clonedIcon.top;
        const isDragged = startLeft !== endLeft || startTop !== endTop;
        if (!isDragged) {
          onIconClick(pageIcon, clonedIcon);
        } else {
          onNotePositionChange({ id: pageIcon.id, x: endLeft, y: endTop });
        }
      });
      clonedIcon.selectable = true;
      clonedIcon.hasControls = false;
      clonedIcon.hasBorders = false;

      // İkonu canvas'a ekleme
      console.log(clonedIcon);
      canvas.add(clonedIcon);
      canvas.renderAll();

      // Yanıp sönme animasyonu
      const blinkAnimation = (times) => {
        if (times > 0) {
          fabric.util.animate({
            startValue: 1,
            endValue: 0,
            duration: 300, // Yanıp sönme süresi (ms)
            easing: fabric.util.ease.easeInOutQuad,
            onChange: function (value) {
              clonedIcon.opacity = value; // Şeffaflık değerini değiştir
              canvas.renderAll(); // Canvas'ı yeniden çiz
            },
            onComplete: function () {
              fabric.util.animate({
                startValue: 0,
                endValue: 1,
                duration: 300,
                easing: fabric.util.ease.easeInOutQuad,
                onChange: function (value) {
                  clonedIcon.opacity = value;
                  canvas.renderAll();
                },
                onComplete: function () {
                  blinkAnimation(times - 1); // Kalan tekrarı azalt ve tekrar çağır
                },
              });
            },
          });
        }
      };

      // Animasyonu 3 kez tekrar et
      blinkAnimation(3);
    });
  };

  removeNoteIcon = (id) => {
    const canvas = this._fc;
    const pageIcons = canvas
      .getObjects()
      .filter((obj) => obj.pageIcon && obj.id === id);
    pageIcons.forEach((pageIcon) => {
      canvas.remove(pageIcon);
    });
  };

  collapseAllGapFilling = (showGapFilling) => {
    const canvas = this._fc;

    const { currentPageItem, displayType } = this.props;
    let icons = [];
    let gapFillingStrategy = null;
    if (showGapFilling) {
      gapFillingStrategy = this.strategyManager.getStrategy("OpenGapFilling");
      icons = currentPageItem.pageIcons.filter(
        (icon) => icon.type === PageIconType.ShowGapFillingItem
      );
    } else {
      gapFillingStrategy = this.strategyManager.getStrategy("CloseGapFilling");
      icons = currentPageItem.pageIcons.filter(
        (icon) => icon.type === PageIconType.CloseGapFillingItem
      );
    }
    icons.forEach((icon) => {
      gapFillingStrategy?.execute(
        icon,
        this.canvasManager,
        this.imageManager,
        this.iconManager
      );
    });
    setTimeout(() => {
      const objects = canvas.getObjects().filter((x) => x.hasOwnProperty("id"));
      if (objects) {
        objects.forEach((obj) => {
          if (obj.pageIcon && obj.id.includes("gapFillingOption")) {
            canvas.bringToFront(obj);
          }
        });
      }
    }, 100);
  };

  collapseSecondLayer = (showSecondLayer) => {
    const canvas = this._fc;

    const { currentPage, bookId, currentPageItem, displayType } = this.props;

    let collapseSecondLayerStrategy = null;
    collapseSecondLayerStrategy = this.strategyManager.getStrategy(
      "CollapseSecondLayer"
    );
    collapseSecondLayerStrategy?.execute(
      {
        bookId,
        entityId: currentPageItem.id,
        width: currentPageItem.width,
        secondLayer: currentPageItem.secondLayer,
      },
      this.canvasManager,
      this.imageManager,
      this.iconManager,
      showSecondLayer
    );
  };

  getQuestionLeftPosition = (canvasWidth, imageWidth, position) => {
    if (position === "left") {
      return 0;
    } else if (position === "right") {
      return canvasWidth - imageWidth;
    } else if (position === "center") {
      return (canvasWidth - imageWidth) / 2;
    }
  };
  setCanvasBackground = () => {
    const {
      userId,
      bookId,
      currentPage,
      currentPageItem,
      currentBlankPage,
      pageItemPosition,
      onNotePositionChange,
      displayType,
      hideIcons,
    } = this.props;
    this.clearItems();
    this.clear();
    const canvas = this._fc;
    this.resetBox();
    const center = canvas.getCenter();
    this.pinchzoom(1, center.left, 0);
    if (displayType === DisplayTypes.Page) {
      canvas.viewportTransform = [1, 0, 0, 1, 0, 0];
      this.pageImageManager.setPageImage(
        userId,
        bookId,
        currentPage,
        this.iconManager,
        hideIcons,
        this.canvasManager.canvasRenderAll()
      );
    } else if (displayType === DisplayTypes.BlankPage) {
      this.pageImageManager.setBlankPage(
        currentBlankPage,
        this.canvasManager.canvasRenderAll()
      );
    } else if (displayType === DisplayTypes.PageItem) {
      canvas.viewportTransform = [1, 0, 0, 1, 0, 0];
      this.pageImageManager.setQuestionImage(
        currentPageItem,
        pageItemPosition,
        this.iconManager,
        hideIcons,
        this.canvasManager.canvasRenderAll()
      );
    }
  };
  /**
   * Sets the background from the dataUrl given
   *
   * @param dataUrl the dataUrl to be used as a background
   * @param options
   */
  setBackgroundFromDataUrl = (dataUrl, options = {}) => {
    let canvas = this._fc;
    let img = new Image();
    img.setAttribute("crossOrigin", "anonymous");
    const { stretched, stretchedX, stretchedY, ...fabricOptions } = options;
    img.onload = () => {
      const imgObj = new fabric.Image(img);
      if (stretched || stretchedX) imgObj.scaleToWidth(canvas.width);
      if (stretched || stretchedY) imgObj.scaleToHeight(canvas.height);
      canvas.setBackgroundImage(
        imgObj,
        () => canvas.renderAll(),
        fabricOptions
      );
    };
    img.src = dataUrl;
  };

  addText = (text, options = {}) => {
    let canvas = this._fc;
    let iText = new fabric.IText(text, options);
    let opts = {
      left: (canvas.getWidth() - iText.width) * 0.5,
      top: (canvas.getHeight() - iText.height) * 0.5,
    };
    Object.assign(options, opts);
    iText.set({
      left: options.left,
      top: options.top,
    });

    canvas.add(iText);
  };

  callEvent = (e, eventFunction) => {
    if (this._selectedTool) eventFunction(e);
  };

  undoLastDrawings = (count) => {
    if (
      this.props.tool === Tool.Pencil ||
      this.props.tool === Tool.Highlighter
    ) {
      if (count === undefined) {
        count = 1;
      }
      setTimeout(() => {
        for (let index = 0; index < count; index++) {
          this.undo();
        }
      }, 50);
    }
  };

  setSelectControls = () => {
    const deleteImg = SvgIcons.getAsImage(SvgIcons.Delete);
    const cloneImg = SvgIcons.getAsImage(SvgIcons.Clone);
    const editImg = SvgIcons.getAsImage(SvgIcons.Edit);
    fabric.Object.prototype.transparentCorners = false;
    fabric.Object.prototype.cornerColor = "#66757f";
    fabric.Object.prototype.cornerStyle = "square";
    function renderIcon(icon, type) {
      return function renderIcon(ctx, left, top, styleOverride, fabricObject) {
        if (type === undefined || fabricObject.type === type) {
          const size = this.cornerSize;
          ctx.save();
          ctx.translate(left, top);
          ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle));
          ctx.drawImage(icon, -size / 2, -size / 2, size, size);
          ctx.restore();
        }
      };
    }

    fabric.Object.prototype.controls.deleteControl = new fabric.Control({
      x: 0.5,
      y: -0.5,
      offsetY: -16,
      offsetX: 16,
      cursorStyle: "pointer",
      mouseUpHandler: this.removeSelected,
      render: renderIcon(deleteImg),
      cornerSize: 24,
    });

    fabric.Object.prototype.controls.clone = new fabric.Control({
      x: -0.5,
      y: -0.5,
      offsetY: -16,
      offsetX: -16,
      cursorStyle: "pointer",
      mouseUpHandler: this.cloneObject,
      render: renderIcon(cloneImg),
      cornerSize: 24,
    });

    fabric.Object.prototype.controls.edit = new fabric.Control({
      x: 0,
      y: -0.5,
      offsetY: -16,
      offsetX: 0,
      cursorStyle: "pointer",
      mouseUpHandler: editObject,
      render: renderIcon(editImg, "i-text"),
      cornerSize: 24,
    });
    function editObject(eventData, transform) {
      const target = transform.target;
    }
  };

  changeToolOnInteraction = () => {
    // silgiye dönüş kısayolu ile silgiye veya önceki toola dönüş burada yapılmakta
    const onSetTool = this.props.onSetTool;
    if (this.props.tool !== Tool.Eraser) {
      this._prevTool = this.props.tool;
      this.undo();
      onSetTool(Tool.Eraser);
    } else {
      onSetTool(this._prevTool);
    }
    if (this._dismissPresent !== undefined) {
      this._dismissPresent();
      this._dismissPresent = undefined;
    }
    this._eraserShortCutActive = false;
  };

  componentDidMount = () => {
    let { tool, value, undoSteps, defaultValue, backgroundColor, height } =
      this.props;

    let canvas = (this._fc = new fabric.Canvas(
      this._canvas /*, {
         preserveObjectStacking: false,
         renderOnAddRemove: false,
         skipTargetFind: true
         }*/
    ));
    // this.iconInitializer.initIcons(height);
    this._initTools(canvas);
    this._initManagers(canvas);

    // set initial backgroundColor
    this._backgroundColor(backgroundColor);

    let selectedTool = this._tools[tool];
    if (selectedTool) selectedTool.configureCanvas(this.props);
    this._selectedTool = selectedTool;
    this.setSelectControls();

    // Control resize
    window.addEventListener("resize", this._resize, false);

    // Initialize History, with maximum number of undo steps
    this._history = new History(undoSteps);

    // Events binding
    canvas.on("object:added", (e) => this.callEvent(e, this._onObjectAdded));
    canvas.on("object:modified", (e) =>
      this.callEvent(e, this._onObjectModified)
    );
    canvas.on("object:removed", (e) =>
      this.callEvent(e, this._onObjectRemoved)
    );

    canvas.on("mouse:down", (e) => {
      const { onNoteAreaSelected, isNoteAreaActive } = this.props;
      if (isNoteAreaActive) {
        const pointer = canvas.getPointer(e.e); // Fabric.js'in getPointer fonksiyonunu kullan
        const { x, y } = pointer; // X ve Y koordinatlarını al
        return onNoteAreaSelected(pointer);
      }
      this.callEvent(e, this._onMouseDown);
    });

    canvas.on("mouse:move", (e) => this.callEvent(e, this._onMouseMove));

    canvas.on("mouse:up", (e) => {
      const { tool } = this.props;
      if (
        tool == Tools.Pencil ||
        tool == Tools.Eraser ||
        tool == Tools.Marker
      ) {
        canvas.isDrawingMode = true;
      }

      if (this._eraserShortCutActive) {
        this.changeToolOnInteraction();
      }
      this.callEvent(e, this._onMouseUp);
      const objects = canvas.getObjects().filter((x) => x.hasOwnProperty("id"));
      if (objects) {
        objects.forEach((obj) => {
          if (obj.pageIcon) {
            canvas.bringToFront(obj);
          }
        });
      }
    });
    canvas.on("mouse:out", (e) => this.callEvent(e, this._onMouseOut));
    canvas.on("object:moving", (e) => this.callEvent(e, this._onObjectMoving));
    canvas.on("object:scaling", (e) =>
      this.callEvent(e, this._onObjectScaling)
    );
    canvas.on("object:rotating", (e) =>
      this.callEvent(e, this._onObjectRotating)
    );

   canvas.on('mouse:wheel', (opt) => {
      const delta = opt.e.deltaY;
      let zoom = canvas.getZoom();
      zoom *= 0.999 ** delta;
      if (zoom > this._maxZoom) zoom = this._maxZoom;
      if (zoom < this._minZoom) zoom = this._minZoom;
      canvas.zoomToPoint({ x: opt.e.offsetX, y: opt.e.offsetY }, zoom);
      opt.e.preventDefault();
      opt.e.stopPropagation();
    });


    const scaleFactor = window.devicePixelRatio || 1;
    canvas.setDimensions(
      {
        width: canvas.width * scaleFactor,
        height: canvas.height * scaleFactor,
      },
      { backstoreOnly: true }
    );

    
    canvas.setZoom(scaleFactor);
    this.setHammer();

    // IText Events fired on Adding Text
    // canvas.on("text:event:changed", console.log)
    // canvas.on("text:selection:changed", console.log)
    // canvas.on("text:editing:entered", console.log)
    // canvas.on("text:editing:exited", console.log)

    this.disableTouchScroll();
    setTimeout(() => {
      this.setCanvasBackground();
    }, 100);

    this._resize();

    // initialize canvas with controlled value if exists
    (value || defaultValue) && this.fromJSON(value || defaultValue);
  };

    setHammer = () => {
    const canvas = this._fc;
    const eraserShortCut = this.props.eraserShortCut;
    // Destroy the previous Hammer instance, if it exists
    if (this._hammertime !== null) {
      this._hammertime.destroy();
    }
    // Enable pinch-to-zoom
    const hammertime = new Hammer(canvas.upperCanvasEl);
    this._hammertime = hammertime;
    hammertime.get('pinch').set({ enable: true });
    hammertime.get('pan').set({ direction: Hammer.DIRECTION_ALL });
    let lastPosX, lastPosY, isDrawingMode, zoomStartScale;

    // Yardımcı fonksiyon: Resmin sınırlarını kontrol eder
    const isWithinImageBounds = (pointer) => {
      const bgImage = canvas.backgroundImage;
      if (!bgImage || !bgImage.lineCoords) return false;

      const { tl, br } = bgImage.lineCoords;
      return (
        pointer.x >= tl.x &&
        pointer.x <= br.x &&
        pointer.y >= tl.y &&
        pointer.y <= br.y
      );
    };

    // Yardımcı fonksiyon: Pan işleminin geçerli olup olmadığını kontrol eder
    const isValidPan = (deltaX, deltaY) => {
      const bgImage = canvas.backgroundImage;
      if (!bgImage || !bgImage.lineCoords) return false;

      const { tl, br } = bgImage.lineCoords;
      const canvasWidth = canvas.width;
      const canvasHeight = canvas.height;

      // Resmin en az %25'i her zaman görünür olmalı
      const minVisibleWidth = bgImage.width * bgImage.scaleX * 0.25;
      const minVisibleHeight = bgImage.height * bgImage.scaleY * 0.25;

      const newLeft = tl.x + deltaX;
      const newRight = br.x + deltaX;
      const newTop = tl.y + deltaY;
      const newBottom = br.y + deltaY;

      const isValidX = newRight >= minVisibleWidth && newLeft <= canvasWidth - minVisibleWidth;
      const isValidY = newBottom >= minVisibleHeight && newTop <= canvasHeight - minVisibleHeight;

      return isValidX && isValidY;
    };

    hammertime.on('pinchstart', (e) => {
      const pointer = { x: e.center.x, y: e.center.y };
      if (!isWithinImageBounds(pointer)) return;

      isDrawingMode = this._fc.isDrawingMode;
      if (isDrawingMode) {
        this._fc.isDrawingMode = false;
      }
      lastPosX = e.center.x;
      lastPosY = e.center.y;
      zoomStartScale = canvas.getZoom();
    });

    hammertime.on('pinchmove', (e) => {
      if (undefined === e.center.x || undefined === e.center.y) return;

      const pointer = { x: e.center.x, y: e.center.y };
      if (!isWithinImageBounds(pointer)) return;

      const newX = e.center.x;
      const newY = e.center.y;
      const deltaX = newX - lastPosX;
      const deltaY = newY - lastPosY;

      if (isValidPan(deltaX, deltaY)) {
        canvas.relativePan({ x: deltaX, y: deltaY });
        lastPosX = newX;
        lastPosY = newY;
      }

      if (deltaX < 50 && deltaY < 50) {
        const point = new fabric.Point(e.center.x, e.center.y);
        let delta = zoomStartScale * e.scale;
        if (delta > this._maxZoom) delta = this._maxZoom;
        if (delta < this._minZoom) delta = this._minZoom;
        canvas.zoomToPoint(point, delta);
        this._onZoomChange();
      }
    });

    hammertime.on('pinchend', (e) => {
      this._fc.isDrawingMode = isDrawingMode;
      this.undoLastDrawings();
    });

    hammertime.on('swipeleft', (e) => {
      if (Math.abs(e.deltaX) > 150 && e.deltaTime < 150) {
        this.undoLastDrawings();
        const onChangePage = this.props.handlePageChange;
        onChangePage(PageNavigationDirection.Next);
      }
    });

    hammertime.on('swiperight', (e) => {
      if (Math.abs(e.deltaX) > 150 && e.deltaTime < 150) {
        this.undoLastDrawings();
        const onChangePage = this.props.handlePageChange;
        onChangePage(PageNavigationDirection.Previous);
      }
    });

    if (eraserShortCut === EraserShortCuts.LongPress) {
      const Press = new Hammer.Press({
        time: 500,
      });
      hammertime.add(Press);
      canvas.upperCanvasEl.oncontextmenu = function (e) {
        e.preventDefault();
      };
      hammertime.on('press', (e) => {
        this._eraserShortCutActive = true;
      });
    }
    if (eraserShortCut === EraserShortCuts.DoubleTap) {
      hammertime.on('doubletap', (e) => {
        this._eraserShortCutActive = true;
      });
    }
  };


  componentWillUnmount = () =>
    window.removeEventListener("resize", this._resize);

  componentDidUpdate = (prevProps, prevState) => {
    if (
      this.props.width !== prevProps.width ||
      this.props.height !== prevProps.height
    ) {
      this._resize();
    }

    if (
      this.props.tool !== prevProps.tool ||
      this.props.lineWidth !== prevProps.lineWidth ||
      this.props.lineColor !== prevProps.lineColor
    ) {
      this._selectedTool = this._tools[this.props.tool];
      //Bring the cursor back to default if it is changed by a tool
      if (this._selectedTool) {
        this._selectedTool.configureCanvas(this.props);
        // this._fc.defaultCursor = "move";
      }
    }
    if (
      (this.props.currentPage !== prevProps.currentPage &&
        this.props.displayType == DisplayTypes.Page) ||
      this.props.displayType !== prevProps.displayType ||
      this.props.currentBlankPage !== prevProps.currentBlankPage ||
      (this.props.currentPageItem !== prevProps.currentPageItem &&
        this.props.displayType === DisplayTypes.PageItem) ||
      this.props.pageItemPosition !== prevProps.pageItemPosition ||
      this.props.hideIcons !== prevProps.hideIcons
    ) {
      this.pageImageManager.destroyActivities();
      this.setCanvasBackground();
    }

    if (this.props.tool !== prevProps.tool) {
      this._selectedTool = this._tools[this.props.tool];
      //Bring the cursor back to default if it is changed by a tool
      this._fc.defaultCursor = "default";
      if (this._selectedTool) {
        this._selectedTool.configureCanvas(this.props);
      }
    }

    if (this.props.backgroundColor !== prevProps.backgroundColor) {
      this._backgroundColor(this.props.backgroundColor);
    }

    if (
      this.props.value !== prevProps.value ||
      (this.props.value && this.props.forceValue)
    ) {
      this.fromJSON(this.props.value);
    }
  };

  render = () => {
    let { className, style, width, height } = this.props;

    let canvasDivStyle = Object.assign(
      {},
      style ? style : {},
      width ? { width: width } : {},
      height ? { height: height } : { height: 512 }
    );
    return (
      <div
        className={className}
        ref={(c) => (this._container = c)}
        style={canvasDivStyle}
      >
        <canvas id={uuid4()} ref={(c) => (this._canvas = c)}>
          Sorry, Canvas HTML5 element is not supported by your browser :(
        </canvas>
      </div>
    );
  };
}

export default SketchField;
